export default class Rent {
    constructor() {
        this.id = "";
        this.identification = "";
        this.number = 0;
        this.numberStr = "0";
        this.statusRental = 1;
        this.type = 1;
        this.typeRent = { id: "", content: "" };
        this.collaborator = { id: "", content: "" };
        this.customer = { id: "", content: "" };
        this.contact = { id: "", content: "" };
        this.periodRent = {};
        this.observationRental = "";
        this.observationServiceOrder = "";
        this.dateAccepted = "";
        this.registeredDate = "";
        this.registeredUser = "";
        this.archived = false;
        this.rejectionReason = "";
    }
    update(data) {
        this.id = data.id;
        this.identification = data.identification;
        this.number = data.number;
        this.numberStr = data.number.toString();
        this.statusRental = data.statusRental;

        if (data.typeRent)
            this.typeRent = { id: data.typeRent.id, content: data.typeRent.name };

        if (data.collaborator)
            this.collaborator = { id: data.collaborator.id, content: data.collaborator.person.companyName + " (" + data.collaborator.person.tradeName + ")" };

        this.customer = { id: data.customerSupplier.id, content: data.customerSupplier.person.companyName + " (" + data.customerSupplier.person.tradeName + ")" };

        if (data.contact)
            this.contact = { id: data.contact.id, content: data.contact.name };

        this.observationRental = data.observationRental;
        this.observationServiceOrder = data.observationServiceOrder;

        this.dateAccepted = data.dateAccepted;
        this.registeredDate = data.registeredDate;
        this.registeredUser = data.registeredUser;
        this.archived = data.archived;
        this.rejectionReason = data.rejectionReason;
    }

}